module.exports = __webpack_public_path__ + "images/2-3_1_About_Team_profile_background.jpg?356b14f";


//////////////////
// WEBPACK FOOTER
// ./assets/component/about/images/2-3_1_About_Team_profile_background.jpg
// module id = 328
// module chunks = 0